import "../../node_modules/postcss/lib/postcss.js";
import { convertToClassSelectorCss, convertToSelectorCSS } from "../transform/jss.js";
import { removeDuplicates } from "../transform/css.js";
import postcss from "../../_virtual/postcss.js";
const toString = async (stylesObject, options = {}) => {
  const cssString = Object.entries(stylesObject).map(([selector, properties]) => {
    if (typeof properties !== "object" || properties === null) {
      return "";
    }
    const isClassSelector = selector.startsWith(".");
    if (isClassSelector) {
      const jssObject = {
        className: selector.substring(1),
        ...properties
      };
      return convertToClassSelectorCss(jssObject);
    } else {
      return convertToSelectorCSS(
        properties,
        selector
      );
    }
  }).filter(Boolean).join("\n\n");
  if (options.prettify) {
    return cssString;
  } else {
    const result = await postcss().process(cssString, { from: void 0 });
    return removeDuplicates(
      result.css.replace(/\s*{\s*/g, "{").replace(/\s*}\s*/g, "}").replace(/\s*;\s*/g, ";").replace(/\s*:\s*/g, ":").replace(/,\s+/g, ",").replace(/\s+\(/g, "(").replace(/\(\s+/g, "(").replace(/\s+\)/g, ")").replace(/\)\s+/g, ")").replace(/[\r\n]+/g, "").trim()
    );
  }
};
export {
  toString
};
//# sourceMappingURL=style.js.map
